var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"turnstile-container"},[_c('div',{ref:"turnstileContainer",staticClass:"turnstile-widget"})])
}
var staticRenderFns = []

export { render, staticRenderFns }